//Moment
import moment from 'moment'

//Enums
import medidaTempo from '@/enums/cadastro/medidaTempo'

export default {
    getDateProximaRetirada(item) {

        const dispensadoEm = moment(item.dispensadoEm)
        const multiplier = this.getMultiplierUnidadeTempoDurante(item.intervaloMedidaTempoId)

        if (item.continuo) {

            const unidadeMedidaTempoMultiplier = this.getUnidadeMedidaTempoMultiplier(item.intervaloMedidaTempoId)

            const entregueXmaterialQuantidade = item.entregue * item.material.quantidade
            const days = entregueXmaterialQuantidade / ((unidadeMedidaTempoMultiplier / item.intervaloTempo) * item.quantidade)

            return dispensadoEm.add(days, 'd')
        }

        if (item.duranteTempo) {

            let days = multiplier * item.duranteTempo

            if (item.prescrito != item.entregue) {
                let diff = null

                if(item.quantidade && item.prescrito < item.entregue) {
                    diff = item.prescrito / item.entregue
                    days = item.duranteTempo / diff
                } else {
                    diff = item.prescrito / item.entregue
                    days = item.duranteTempo / diff
                }
            }

            return dispensadoEm.add(days, 'd')
        }

        return null
    },
    getMultiplierUnidadeTempoDurante(unidadesMedidaTempoDurante) {

        switch (unidadesMedidaTempoDurante) {

            case medidaTempo.SEMANAS: return 7
            case medidaTempo.MESES: return 30
        }

        return 1
    },
    getUnidadeMedidaTempoMultiplier(intervaloMedidaTempoId) {

        switch (intervaloMedidaTempoId) {

            case medidaTempo.MINUTOS: return 24 * 60
            case medidaTempo.HORAS: return 24
            case medidaTempo.DIAS: return 1
            case medidaTempo.SEMANAS: return 1
            case medidaTempo.MESES: return 1
        }

        return 0
    },
}